export const availabilityStatusesTranslationKeys = {
  AVAILABLE_FOR_RENT: 'Disponible para alquilar',
  AVAILABLE_FOR_SALE: 'Disponible para vender',
  RENTED: 'Alquilado',
  SOLD: 'Vendido',
  RESERVED: 'Reservado',
}
